import { createAsyncThunk } from '@reduxjs/toolkit';

import { getOnboardingQuery } from '../../api/onboarding.api';
import type { OnboardingStep } from '../types/onboarding';

export const fetchOnboardingDataThunk = createAsyncThunk<
    OnboardingStep[],
    void,
    AsyncThunkConfig<unknown>
>('onboarding/initOnboardingData', async (_, { dispatch, rejectWithValue }) => {
    try {
        return await dispatch(getOnboardingQuery({ locale: 'en' })).unwrap();
    } catch (error) {
        return rejectWithValue(error);
    }
});
